import * as React from 'react';
import { AbstractAttributeCell, AttributeCellProps } from './AbstractAttributeCell';

interface HeadlineCellProps extends AttributeCellProps {
}

export class HeadlineCell extends AbstractAttributeCell<HeadlineCellProps> {
    protected renderInner(): JSX.Element | null | undefined {
        const props = this.props;
        const attr = props.attr;
        const product = props.product;

        const content = this.buildContent(props, product, attr, undefined);
        if (content || !props.hideEmpty) {
            return this.link(<h3 className="pf-title">{content}</h3>);
        } else {
            return null;
        }
    }
}
